import React from "react"

const moneyField = ({ input, label, placeholder, className, icon, onIconClick, meta: { touched, error, active } }) => (
  <div className={className || "form-group"}>
    <label>{label}</label>
    <input {...input} placeholder={placeholder || label} type="number" min="0" step="0.01"/>
    { icon && React.createElement(icon, {onClick: onIconClick, className: 'icon'}) }
    {touched && error && !active && <span className="error">{error}</span>}
  </div>
)

export { moneyField }